<mat-dialog-content style="padding: 0 40px; width: 300px; overflow-y: hidden">
  <lemon-dialog-header> Muuta VAT-numero </lemon-dialog-header>

  <div>
    <form novalidate style="margin: 0">
      <mat-form-field subscriptSizing="dynamic" class="vat-field">
        <mat-label>VAT-numero</mat-label>
        <input type="text" [formField]="lomake.vat" matInput data-lpignore="true" />
        <mat-error>VAT-numero puuttuu</mat-error>
      </mat-form-field>
      <!-- Ei käytetä mat-hint elementtiä vaan omaa diviä, jotta saadaan osaksi dokumentin korkeutta -->
      <div class="vat-validation-result mat-mdc-form-field-subscript-wrapper">
        {{ vatTunnuksenValidointitulos | async }}
      </div>
    </form>
  </div>
</mat-dialog-content>
<mat-dialog-actions style="padding-left: 0; padding-right: 0; justify-content: space-around; justify-content: space-evenly">
  <app-secondary-button [focusRegionStart]="true" mat-dialog-close actionId="Peruuta (kirjauksen VAT-numeron muutos dialog)">Peruuta</app-secondary-button>
  <app-primary-button (click)="muuta()" actionId="Muuta kirjauksen VAT-numero" [actionContext]="$any(lomake().value())" [disabled]="!vatValidointiOnnistui()">Muuta VAT-numero</app-primary-button>
</mat-dialog-actions>
